import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'dateago'})
export class DateAgoPipe implements PipeTransform {
	transform(val: any = null): any {
		if (!val) {
			return null;
		}

		return this.timeSince(new Date(val));
	}

	timeSince(date: Date) {
		const currenttime = new Date().getTime();
		const datetime = date.getTime();
		const isAgo = datetime < currenttime;

		const seconds = Math.floor(Math.abs(currenttime - datetime) / 1000);

		let interval = Math.floor(seconds / 31536000);

		if (interval > 1) {
			return (!isAgo ? 'in ' : '') + interval + ' years ' + (isAgo ? 'ago' : '');
		}
		interval = Math.floor(seconds / 2592000);
		if (interval > 1) {
			return (!isAgo ? 'in ' : '') + interval + ' months ' + (isAgo ? 'ago' : '');
		}
		interval = Math.floor(seconds / 86400);
		if (interval >= 1) {
			return (!isAgo ? 'in ' : '') + interval + ' day' + (interval === 1 ? '' : 's') + ' ' + (isAgo ? 'ago' : '');
		}
		interval = Math.floor(seconds / 3600);
		if (interval > 1) {
			return (!isAgo ? 'in ' : '') + interval + ' hours ' + (isAgo ? 'ago' : '');
		}
		interval = Math.floor(seconds / 60);
		if (interval > 1) {
			return (!isAgo ? 'in ' : '') + interval + ' minutes ' + (isAgo ? 'ago' : '');
		}
		return (!isAgo ? 'in ' : '') + Math.floor(seconds) + ' seconds ' + (isAgo ? 'ago' : '');
	}
}
